import React, { Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import MainLayoutLogged from "./layout/MainLayoutLogged";
import MainLayoutNotLogged from "./layout/MainLayoutNotLogged";
import { privateRoutes, publicRoutes } from "./routes/routes";
import { TailSpin } from "react-loader-spinner";
import "./App.css";
import "animate.css";
import NotFound from "./components/NotFound";
import ReactGA from "react-ga4";

const App = () => {
  useEffect(() => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

    if (measurementId) {
      ReactGA.initialize(measurementId);
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Suspense
        fallback={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <TailSpin
              height="80"
              width="80"
              color="#4fa94d"
              ariaLabel="loading"
            />
          </div>
        }
      >
        <Routes>
          <Route element={<MainLayoutNotLogged />}>
            {publicRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<TrackPageView>{route.element}</TrackPageView>}
              />
            ))}
          </Route>
          <Route element={<MainLayoutLogged />}>
            {privateRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<TrackPageView>{route.element}</TrackPageView>}
              />
            ))}
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

const TrackPageView = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return children;
};

export default App;
